import { useMemo } from "react";
import type { TokenAutomation } from "hooks/firestore/models/tokenAutomation";
import type { TokenAllocations } from "@/features/betslip/hooks/useTokenAllocations";
import {
  byAllocationPriority,
  byBetslipPriority,
} from "@/features/betslip/utils/tokenSort";

export const useSortedTokens = (
  allocations: TokenAllocations | null | undefined,
  automations: TokenAutomation[] | null | undefined,
) => {
  const sortedAutomations = useMemo(
    () => (automations ?? []).slice().sort(byBetslipPriority),
    [automations],
  );

  const automationPriorityMap = useMemo(
    () =>
      new Map(
        sortedAutomations.map((a) => [
          a.automationId,
          a.attributes?.tokenBetSlipPriority ?? 0,
        ]),
      ),
    [sortedAutomations],
  );

  const sortedAllocations = useMemo(
    () =>
      (allocations ?? []).slice().sort((a, b) => {
        const aPrio = automationPriorityMap.get(a.automationId) ?? 0;
        const bPrio = automationPriorityMap.get(b.automationId) ?? 0;
        const automationDelta = bPrio - aPrio;
        if (automationDelta !== 0) return automationDelta;
        return byAllocationPriority(a, b);
      }),
    [allocations, automationPriorityMap],
  );

  return { sortedAutomations, sortedAllocations };
};
